(() => {
  const mobileFooter = window.matchMedia('(max-width: 39.999rem)');

  const syncFooterAccordions = (root = document) => {
    root.querySelectorAll('[data-rv-footer-accordion]').forEach((accordion) => {
      const summary = accordion.querySelector(':scope > summary');

      if (accordion.dataset.rvDesktopLockBound !== 'true') {
        accordion.addEventListener('toggle', () => {
          if (!mobileFooter.matches && !accordion.open) accordion.open = true;
        });
        accordion.dataset.rvDesktopLockBound = 'true';
      }

      if (mobileFooter.matches) {
        summary?.removeAttribute('tabindex');
        summary?.removeAttribute('aria-disabled');
        if (accordion.dataset.rvMobileAccordionReady !== 'true') {
          accordion.open = false;
          accordion.dataset.rvMobileAccordionReady = 'true';
        }
        return;
      }

      accordion.open = true;
      summary?.setAttribute('tabindex', '-1');
      summary?.setAttribute('aria-disabled', 'true');
      delete accordion.dataset.rvMobileAccordionReady;
    });
  };

  syncFooterAccordions();
  mobileFooter.addEventListener?.('change', () => syncFooterAccordions());
  document.addEventListener('shopify:section:load', (event) => syncFooterAccordions(event.target));
})();
